export enum Role {
    all = '',
    admin = 'admin',
    finance = 'finance',
    custom = 'custom'
}
